import * as actionTypes from '../actionTypes/OfferingsActionTypes';

export const setOfferingSelected = (payload) => ({
    type: actionTypes.SET_OFFERING_SELECTED,
    payload,
});

export const setOfferingUnselected = (payload) => ({
    type: actionTypes.SET_OFFERING_UNSELECTED,
    payload,
});

export const setInstallationSelected = (payload) => ({
    type: actionTypes.SET_INSTALLATION_SELECTED,
    payload,
});

export const setInstallationUnselected = (payload) => ({
    type: actionTypes.SET_INSTALLATION_UNSELECTED,
    payload,
});

export const setCarePlanUnSelected = () => ({
    type: actionTypes.SET_CARE_PLAN_UNSELECTED,
});

export const setOfferingPartUnSelected = (payload) => ({
    type: actionTypes.SET_OFFERING_PART_UNSELECTED,
    payload,
});

export default {
    setOfferingSelected,
    setOfferingUnselected,
    setInstallationSelected,
    setInstallationUnselected,
    setCarePlanUnSelected,
    setOfferingPartUnSelected,
};
